var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      },
      model: _vm.dataFrom,
      rules: _vm.dataRule
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("理赔结果"),
      prop: "result"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("理赔结果")
    },
    on: {
      change: _vm.resultChange
    },
    model: {
      value: _vm.dataFrom.result,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "result", $$v);
      },
      expression: "dataFrom.result"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("理赔成功")))]), _c("a-select-option", {
    attrs: {
      value: 2
    }
  }, [_vm._v(_vm._s(_vm.$t("理赔失败")))])], 1)], 1), _vm.dataFrom.result == 1 ? _c("a-form-model-item", {
    staticClass: "contBox",
    attrs: {
      label: _vm.$t("赔付金额"),
      prop: "amount"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      flex: "1"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("赔付金额")
    },
    model: {
      value: _vm.dataFrom.amount,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "amount", $$v);
      },
      expression: "dataFrom.amount"
    }
  }), _c("span", {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId))))])], 1) : _vm._e(), _vm.dataFrom.result == 1 ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("赔付时间"),
      prop: "payoutAt"
    }
  }, [_c("a-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      format: _vm.getFormatDate(),
      placeholder: _vm.$t("请选择") + _vm.$t("赔付时间")
    },
    model: {
      value: _vm.dataFrom.payoutAt,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "payoutAt", $$v);
      },
      expression: "dataFrom.payoutAt"
    }
  })], 1) : _vm._e(), _vm.dataFrom.result == 1 && _vm.isBtnShow ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("是否需要物理件回寄"),
      prop: "isBack"
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.dataFrom.isBack,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "isBack", $$v);
      },
      expression: "dataFrom.isBack"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("否")))]), _c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("是")))])], 1)], 1) : _vm._e(), _vm.dataFrom.isBack == 1 && _vm.mailingDetail.consigneeInfo && _vm.dataFrom.result == 1 ? _c("a-form-model-item", {
    staticClass: "contBox",
    attrs: {
      label: _vm.$t("收件信息")
    }
  }, [_c("div", [_vm._v(" " + _vm._s(_vm.$t("姓名")) + ":" + _vm._s(_vm.mailingDetail.consigneeInfo.name) + " "), _c("div", [_vm._v(_vm._s(_vm.$t("手机号")) + ":" + _vm._s(_vm.mailingDetail.consigneeInfo.mobile))])]), _c("div", [_vm._v(_vm._s(_vm.$t("详细地址")) + ":" + _vm._s(_vm.mailingDetail.consigneeInfo.address))])]) : _vm._e(), _vm.dataFrom.isBack == 1 && _vm.dataFrom.result == 1 ? _c("a-form-model-item", {
    staticClass: "contBox",
    attrs: {
      label: _vm.$t("回寄资料"),
      prop: "documentList"
    }
  }, [_vm.dataFrom.isBack == 1 ? _c("a-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      bordered: "",
      columns: _vm.closeCasedocumentListColumns,
      "data-source": _vm.mailingDetail.list,
      align: "center",
      pagination: false,
      rowKey: "documentId",
      scroll: {
        y: 300
      }
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (text, record, index) {
        return [_vm._v(" " + _vm._s(index + 1) + " ")];
      }
    }, {
      key: "mail",
      fn: function (text, record, index) {
        return [_c("a-checkbox", {
          attrs: {
            checked: record.isChecked
          },
          on: {
            change: function ($event) {
              return _vm.mailChange(index);
            }
          }
        })];
      }
    }], null, false, 614371250)
  }, _vm._l(_vm.closeCasedocumentListColumns, function (item, i) {
    return _c("span", {
      key: i,
      attrs: {
        slot: item.slots.title
      },
      slot: item.slots.title
    }, [_vm._v(_vm._s(_vm.$t(item.slots.title)))]);
  }), 0) : _vm._e()], 1) : _vm._e(), _vm.dataFrom.isBack == 1 && _vm.dataFrom.result == 1 ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("物流公司"),
      prop: "logisticsCompany"
    }
  }, [_c("a-select", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请选择") + _vm.$t("物流公司")
    },
    model: {
      value: _vm.dataFrom.logisticsCompany,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "logisticsCompany", $$v);
      },
      expression: "dataFrom.logisticsCompany"
    }
  }, _vm._l(_vm.logisticsSelectList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item,
        label: item
      }
    }, [_vm._v(_vm._s(item) + " ")]);
  }), 1)], 1) : _vm._e(), _vm.dataFrom.isBack == 1 && _vm.dataFrom.result == 1 ? _c("a-form-model-item", {
    staticClass: "contBox",
    attrs: {
      label: _vm.$t("运单号"),
      prop: "shipmentNum"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("运单号")
    },
    model: {
      value: _vm.dataFrom.shipmentNum,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "shipmentNum", $$v);
      },
      expression: "dataFrom.shipmentNum"
    }
  })], 1) : _vm._e(), _vm.dataFrom.result ? _c("a-form-model-item", {
    staticClass: "contBox",
    attrs: {
      label: _vm.dataFrom.result == 1 ? _vm.$t("备注") : _vm.$t("原因"),
      prop: "remark"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.dataFrom.result == 1 ? _vm.$t("备注") : _vm.$t("原因")
    },
    model: {
      value: _vm.dataFrom.remark,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "remark", $$v);
      },
      expression: "dataFrom.remark"
    }
  })], 1) : _vm._e()], 1), _c("div", {
    staticClass: "btnBox"
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.handleSure
    }
  }, [_vm._v(_vm._s(_vm.$t("提交")))])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };